export default "__VITE_ASSET__Bbo3AE1F__"